import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Rooms.css';

const Apartments: React.FC = () => {
  return (
    <div className="rooms-container">
      <div className="rooms-content">

        <div className="apartment-room">
          <div className="apartment-images">
            <img src={`${process.env.PUBLIC_URL}/images/Brora/living_room.jpg`} alt="outside of Aaron Glen Guesthouse" width="250" height="187.5" />
            <img src={`${process.env.PUBLIC_URL}/images/Brora/kitchen_2.jpg`} alt="double bedroom at Aaron Glen Guesthouse" />
          </div>
          <div className="apartment-info">
            <h2><strong>Brora</strong></h2>
            <p>
            Our elegant first-floor Brora apartment features a double and single bed, modern en-suite, and a fully equipped kitchen/living space overlooking a quiet courtyard.
            </p>
            <p><Link to="/brora">View more details about Brora apartment</Link></p>
          </div>
        </div>

        <div className="apartment-room">
          <div className="apartment-images">
            <img src={`${process.env.PUBLIC_URL}/images/Cairn/kitchen_1.jpg`} alt="bathroom sink at Aaron Glen Guesthouse" />
            <img src={`${process.env.PUBLIC_URL}/images/Cairn/living_room.jpg`} alt="twin bedroom at Aaron Glen Guesthouse" />
          </div>
          <div className="apartment-info">
            <h2><strong>Cairn</strong></h2>
            <p>
            Cairn is a bright first-floor apartment with a double and single bed, en-suite bathroom, and open-plan kitchen/living area enjoying morning sun and Pentland Hill views.
            </p>
            <p><Link to="/cairn">View more details about Cairn apartment</Link></p>
          </div>
        </div>

        <div className="apartment-room">
          <div className="apartment-images">
            <img src={`${process.env.PUBLIC_URL}/images/Kinloch/kitchen_2.jpg`} alt="tea room at Aaron Glen Guesthouse" />
            <img src={`${process.env.PUBLIC_URL}/images/Kinloch/living_room_1.jpg`} alt="outside again" />
          </div>
          <div className="apartment-info">
            <h2><strong>Kinloch</strong></h2>
            <p>
            Kinloch is a spacious ground-floor two-bedroom apartment with wheelchair access, a twin room with wetroom, and a master bedroom sleeping three.
            </p>
            <p><Link to="/kinloch">View more details about Kinloch apartment</Link></p>
          </div>
        </div>

        <p>
          <strong>
            To enquire about booking, visit the <Link to="/tariff">rates and booking page</Link>.
          </strong>
        </p>

      </div>
    </div>
  );
};

export default Apartments;